import { render, staticRenderFns } from "./im-text-message.vue?vue&type=template&id=7f8b09ba&scoped=true"
import script from "./im-text-message.vue?vue&type=script&lang=js"
export * from "./im-text-message.vue?vue&type=script&lang=js"
import style0 from "./im-text-message.vue?vue&type=style&index=0&id=7f8b09ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8b09ba",
  null
  
)

export default component.exports